export default __webpack_public_path__ + "static/media/info-02.d75acf80.png";